import React from 'react';

class PrefabInstanceEditor extends React.Component {

  render() {
    return (
      <div>
        Edycja instancji
        <div>a tu prefab</div>
      </div>
    );
  }
}

PrefabInstanceEditor.propTypes = {};

export default PrefabInstanceEditor;



// WEBPACK FOOTER //
// ./src/components/Inspector/prefabInstanceEditor.js